import React, {Component} from 'react';
import List from './List';

class SideDrawer extends Component {
    constructor(props) {
      super(props);
        this.state = {
            accepted:true,
            rejected:true

        }
    }

    clearLists(){
        this.props.clear()
    }

    hide=()=>{
        this.props.hide()
    }
    
    render(){
       // {this.state.accepted &&<i className="check fas fa-check" onClick={this.accept}/>} {this.state.rejected &&<i className="cross fas fa-times" onClick={this.reject}/>}
        let drawerClasses = 'side-drawer';
        if(this.props.show){
            drawerClasses='side-drawer open';
    }
 
    return(
    <nav className={drawerClasses}> 
        <button className="closeBtn" onClick={this.hide}>X</button>
        
        <ul> 
  
    {this.props.lists.map((list,index)=>(<List list={list} index={index} key={index}></List>))}
        </ul>
        
        <button className="clearBtn" onClick={()=>this.clearLists()}>Clear List</button>
    </nav>
);
    }
}
export default SideDrawer;